import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthProvider";
// import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import NotificationProvider from "./common/components/Notifications/NotificationProvider";
import { DashboardProvider } from "./context/DashboardProvider";
import { GeneralProvider } from "./context/GeneralProvider";

// if (process.env.NODE_ENV === "production") {
//   disableReactDevTools();
// }

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <DashboardProvider>
        <GeneralProvider>
          <NotificationProvider>
            <App />
          </NotificationProvider>
        </GeneralProvider>
      </DashboardProvider>
    </AuthProvider>
  </React.StrictMode>,
);
